/** Links the guide editor builds: the site preview, site-relative photos, Google Maps. */

const DEFAULT_SITE_ORIGIN = 'https://curated-by-blog-git-staging-tripsby.vercel.app';

/**
 * The Curated-By-Blog site the Command Center links to and loads photos from
 * (`VITE_GUIDE_SITE_ORIGIN`, set per environment in scripts/deployment/config/).
 * Staging: the Vercel staging preview. Production: https://tripsby.ai.
 */
export function guideSiteOrigin(): string {
  const origin = (import.meta.env.VITE_GUIDE_SITE_ORIGIN as string | undefined) || DEFAULT_SITE_ORIGIN;
  return origin.replace(/\/$/, '');
}

/** A Vercel preview deployment is SSO-walled and lags a save; the public site is neither. */
export function isPreviewOrigin(): boolean {
  return /\.vercel\.app$/i.test(new URL(guideSiteOrigin()).hostname);
}

/** A guide's page on the site (on the staging preview a save can take a minute to show). */
export function guidePreviewUrl(slug: string): string {
  return `${guideSiteOrigin()}/destinations/${slug}`;
}

/**
 * A guide photo as a browser can fetch it. The Content API hands back site-relative,
 * signed `/api/place-photo/...` paths; they live on the site, not on the Command Center.
 */
export function resolveSiteUrl(src: string | null | undefined): string | undefined {
  if (!src) return undefined;
  if (/^https?:\/\//i.test(src)) return src;
  return src.startsWith('/') ? `${guideSiteOrigin()}${src}` : undefined;
}

export function mapsLink(name: string, address?: string, placeId?: string): string {
  const query = encodeURIComponent([name, address].filter(Boolean).join(' '));
  const id = placeId ? `&query_place_id=${encodeURIComponent(placeId)}` : '';
  return `https://www.google.com/maps/search/?api=1&query=${query}${id}`;
}
